import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'
import Rails from '@rails/ujs'
import { flashError } from '@app/javascript/classes/flashMessages'

export default class extends Controller {
  static targets = ['listLoadingIndicator', 'downloadLoadingIndicator', 'downloadButton', 'nameInput', 'nameLabel', 'saveName']
  static values = { searchParams: String }

  connect() {
    useDispatch(this)

    this.showDownloading(false)
    this.loadActiveFilters()
    this.loadActions(0)
  }

  loadActiveFilters() {
    Rails.ajax({
      type: 'GET',
      url: '/actions_report/active_filters',
      dataType: 'script',
      data: this.searchParamsValue
    })
  }

  loadActions(offset) {
    Rails.ajax({
      type: 'GET',
      url: '/actions_report/paged_actions',
      dataType: 'script',
      data: `${this.searchParamsValue}&offset=${offset}`,
      success: (data) => {
        const doc = new DOMParser().parseFromString(data.html, 'text/html')
        this.listElement().querySelector('ol').innerHTML += doc.body.innerHTML
        if (data.offset >= data.total) {
          this.listLoadingIndicatorTarget.setAttribute('hidden', '')
        } else {
          this.loadActions(data.offset)
        }
      }
    })
  }

  generateActionPDF() {
    this.showDownloading(true)
    const formParams = $('#actions_report_form').serialize()
    Rails.ajax({
      type: 'GET',
      url: '/actions_report_preview/generate_pdf',
      dataType: 'script',
      data: `${this.searchParamsValue}&${formParams}`,
      success: (response) => {
        this.download(response)
        this.showDownloading(false)
      },
      error: () => {
        flashError('Error generating report')
        this.showDownloading(false)
      }
    })
  }

  saveName() {
    this.nameLabelTarget.innerHTML = this.nameInputTarget.value
  }

  validateName() {
    if (!this.nameInputTarget.value) {
      this.saveNameTarget.classList.add('pointer-events-none')
      this.saveNameTarget.classList.add('opacity-50')
      flashError('Report must have a name')
    } else {
      this.saveNameTarget.classList.remove('pointer-events-none')
      this.saveNameTarget.classList.remove('opacity-50')
    }
  }

  cancelNameChange() {
    this.nameInputTarget.value = this.nameLabelTarget.innerHTML
    this.saveNameTarget.classList.remove('pointer-events-none')
    this.saveNameTarget.classList.remove('opacity-50')
  }

  listElement() {
    return this.element.querySelector('#actions_list')
  }

  showDownloading(shown) {
    if (!this.hasDownloadLoadingIndicatorTarget || !this.hasDownloadButtonTarget) {
      return
    }
    if (shown) {
      this.downloadLoadingIndicatorTarget.removeAttribute('hidden')
      this.downloadButtonTarget.setAttribute('hidden', '')
    } else {
      this.downloadLoadingIndicatorTarget.setAttribute('hidden', '')
      this.downloadButtonTarget.removeAttribute('hidden')
    }
  }

  download(url) {
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = 'actions_report.pdf'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
